import React from 'react';
import '../styles/forms.css';
import { Col, FormGroup } from 'reactstrap';
import { getEstados } from '../requests/req_general';
import { getAlertas2 } from '../requests/req_alertas';
import { getCategorias } from "../requests/req_perfil";
import { notifica } from '../requests/utils';

export default class FrmAlertas extends React.Component {
  constructor(props) {
    super(props);
    this.state = { datos: null, estados: [], idEstado: null, idEstados: 0, idCategoria: 0 }
    this.getEstados = this.getEstados.bind(this);
    this.llenaCampos = this.llenaCampos.bind(this);
    this.llenarCategoria = this.llenarCategoria.bind(this);
    this.obtieneDatos = this.obtieneDatos.bind(this);
    this.MaxLength = this.MaxLength.bind(this);
  }

  componentWillMount() {
    getEstados((e) => this.setState({ estados: e }));
  }

  componentDidMount() {

    this.idAlerta = document.getElementById('lbl_Modal').innerText;

    if (this.idAlerta !== "0") {
      getAlertas2((a) => this.obtieneDatos(a));
    }

    var id = document.getElementById('lbl_Modal').innerText;

    if (id !== '0') {
      var d = this.props.info.filter(i => i.idAlertaCandidato === parseInt(id, 10));

      this.llenaCampos(d[0]);
      this.setState({ datos: d })
    }
    getCategorias((x) => this.llenarCategoria(x));
  }

  obtieneDatos(res) {
    if (res.code === 0) {
      if (res.data.length > 0) {
        this.setState({ idEstados: res.data[0]['idEstado'] })
        this.setState({ idCategoria: res.data[0]['idCategoria'] })
      } else {
        notifica('info', 'Aún no has generado ninguna alerta.', 'Info');
      }
    } else {
      notifica('warning', res.message, 'Alerta');
    }
  }

  llenarCategoria(items) {
    if (items != null) {
      if (Array.isArray(items)) {
        if (items.length > 0) {
          var dv = document.getElementById("idCategoria");
          dv.innerHTML = '';
          let option = document.createElement("option");
          option.text = "Selecciona...";
          option.value = 0;
          dv.add(option);
          for (var i = 0; i < items.length; i++) {
            let option = document.createElement("option");
            option.text = items[i].descripcion;
            option.value = items[i].valor;
            dv.add(option);
          }
          dv.add(option);
          if (this.state.cat !== '') {
            dv.value = this.state.cat;
          }
        }
      }
    }
  }

  llenaCampos(dats) {
    for (var key in dats) {
      var inp = document.getElementsByName(key);
      if (inp[0] !== undefined) {
        if (key !== 'idEstatus') {
          inp[0].value = dats[key];
        } else {
          inp[0].checked = (dats[key] === 1 ? true : false);
        }
      }
    }
  }

  getEstados() {
    if (this.state.estados !== null) {
      return this.state.estados.map((f, index) => {
        return (<option value={f.idEstado} key={index}>{f.estado}</option>);
      });
    }
  }

  MaxLength(e) {
    if (e.target.value.length === 20) {
      notifica('info', 'El limite son 20 letras', 'Info');
    }
  }

  render() {
    return (
      <FormGroup className="APL_Frm_dv Frm_Alrts" id='dv_Alerts' row>
        <Col sm={6} md={6} lg={6} >
          <label>Palabra Clave <span style={{ color: 'red' }}>*</span></label>
          <input type='hidden' className='frm frm_Alrts' name='idAlertaCandidato' id='idAlertaCandidato' />
          <input type='text' className='frm frm_Alrts' name='palabraClave' id='palabraClave' maxLength={20} onChange={this.MaxLength} />
        </Col>
        <Col sm={6} md={6} lg={6} >
          <label>Categoría <span style={{ color: 'red' }}>*</span></label>
          <select className='frm frm_Alrts' onChange={(e) => { this.setState({ idCategoria: e.target.value }) }} name='idCategoria' id="idCategoria" value={this.state.idCategoria}>
            {/* {this.getCategorias()} */}
          </select>
        </Col>
        <Col sm={6} md={6} lg={6} >
          <label>Estados <span style={{ color: 'red' }}>*</span></label>
          <select className='frm frm_Alrts' onChange={(e) => { this.setState({ idEstados: e.target.value }) }} name='idEstado' id="idEstado" value={this.state.idEstados} >
            <option value="0">Selecciona...</option>
            {this.getEstados()}
          </select>
        </Col>
        <Col sm={6} md={6} lg={6} >
          <label>Sueldo Mínimo Deseado <span style={{ color: 'red' }}>*</span></label>
          <input type='number' className='frm frm_Alrts' name='salarioMinimo' id="salarioMinimo" />
        </Col>
        <Col sm={6} md={6} lg={6} >
          <label>¿Quieres recibir correo electrónico de esta alerta?</label>
          <label className="switch">
            <input type="checkbox" className="fctlg frm_Alrts" name='idEstatus' />
            <span className="slider round"></span>
          </label>
        </Col>
        <Col sm={12} md={12} lg={12} >
          <label><span style={{ color: 'red' }}>*</span> Campos Obligatorios</label>
        </Col>
      </FormGroup>
    );
  }
}
